import React, { useMemo, useState, useEffect } from 'react'
import Pie from 'component/chart/base'
import NestMenu from 'component/nestMenu'
import { color } from '../color'
import styles from './index.module.less'

export const SOURCE_TYPE = {
  INSPIRATION: 'INSPIRATION',
  HOME: 'HOME',
  OTHER: 'OTHER'
}

export default ({
  style,
  chartOption,
  isActive = true, // 是否显示选中状态
  disabled, // 禁止交互
  centerText,
  sourceType = SOURCE_TYPE.HOME,
  inspirationId, // 需要的参数 灵感集id
  markStatus, // 需要的参数 用户身份
  menuOption,
  menuTitle = '款式',
  data = [],
  onParentClick,
  menuClassName,
}) => {
  const [parentData, setParentData] = useState({})

  useEffect(() => {
    setParentData({ // 适配两种数据
      ...data[0],
      color: color[0],
      data: data[0]
    })
  }, [data])

  const config = useMemo(() => {
    const baseConfig = {
      color,
      tooltip: {
        trigger: 'item',
        enterable: true,
        formatter: (a) => {
          const _a = Array.isArray(a) ? a : [a]
          let tip = ''
          _a.forEach((m) => {
            tip += `<div style='width:200px;'>
              <div style='overflow:hidden;
              white-space: nowrap;
              text-overflow: ellipsis; 
              display: inline-block;
              width: 180px;'>${m.marker}${m.name}</div>
              <div style='display:flex;margin-left:16px;align-items: center;'>
                <span>${m.data?.value}&nbsp;</span>
                <span style='color: var(--m-text-3);'>款</span>
                <span style='color: var(--m-line-1);margin:0px 6px;'>|</span>
                <span style='color: var(--m-text-3);'>占比&nbsp;</span>
                <span>${m.data?.percentage}%</span>
              </div>
            </div>`
          })
          if (sourceType === SOURCE_TYPE.OTHER) {
            tip += `<a target="_blank" 
            style='color: var(--m-text-1);text-align: right;width:200px;display:block;margin-top:6px;'
            href=${`/meinian/home/coll/detail/${inspirationId}?inspirationId=${inspirationId}&userIdList=${a.data.itemKey}&markStatus=${markStatus}`}>查看款式 &gt;</a>`
          } else if (sourceType === SOURCE_TYPE.INSPIRATION) {
            tip += `<a target="_blank" 
            style='color: var(--m-text-1);text-align: right;width:200px;display:block;margin-top:6px;'
            href=${`/meinian/home/coll/detail/${inspirationId}?inspirationId=${inspirationId}&platformId=${a.data.itemKey}`}>查看款式 &gt;</a>`
          } else if (sourceType === SOURCE_TYPE.HOME) {
            tip += `<a target="_blank" 
            style='color: var(--m-text-1);text-align: right;width:200px;display:block;margin-top:6px;'
            href=${`/meinian/home/all?platformId=${a.data.itemKey}`}>查看款式 &gt;</a>`
          }
          return tip
        }
      },
      grid: {
        top: 100,
        left: 100,
        right: 0,
      },
      series: [
        {
          type: 'pie',
          radius: ['65%', '95%'],
          center: ['50%', '50%'],
          label: {
            show: false,
          },
          labelLine: {
            show: false
          },
          data
        }
      ]
    }
    return baseConfig
  }, [JSON.stringify(data), parentData])

  const _onParentClick = (item) => {
    if (item.seriesId === 'children') {
      return
    }
    const _obj = { // 适配两种数据
      ...item,
      data: item.data
    }
    setParentData({ ..._obj })
    onParentClick?.(_obj)
  }

  const centerTextDom = useMemo(() => {
    if (centerText) {
      return <div className={styles['meinian-pie-center-text']}>{centerText}</div>
    }
    return <div className={styles['meinian-pie-center-text']} style={{ backgroundColor: parentData.color }} />
  }, [centerText, parentData])

  return (<div className={styles['meinian-double-pie-attr-chart']} style={style}>
    <div className="meinian-double-pie-attr-chart-menu">
      {menuTitle && <div className="meinian-double-pie-attr-chart-menu-title">{menuTitle}</div>}
      <NestMenu
        isPoint
        menu={data}
        color={color}
        disabled={disabled}
        value={isActive ? parentData?.data?.itemKey : null}
        onParentClick={(val) => _onParentClick({ data: val, color: val.color })}
        {...menuOption}
        className={menuClassName}
      />
    </div>
    <Pie
      className="meinian-double-pie-attr-chart-pie"
      customConfig={config}
      type={null}
      onClickSeries={_onParentClick}
      style={{ width: '240px', height: '240px' }}
      contentSlot={centerTextDom}
      {...chartOption}
    />
  </div>)
}
